import { useContext, useState } from 'react';
import { useApiCall } from '../../../../component/custom-hooks/api-call';
import LeftSidePopupLayout from '../../../../component/popup/modal-layout';
import Style from './style.module.css'
import XCloseIcon from '../../../../component/icons/x-close';
import { GlobalContext } from '../../../../context/Context';
import InnerLoader from '../../../../component/ui/loader/inner-loader';

const UpdateCoverPhoto = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, usedCover = null}) => {
  let { state, dispatch } = useContext(GlobalContext);
  const [selectedCover, setSelectedCover] = useState(usedCover);
  const [btnLoader, setBtnLoader] = useState(false);
  
  const apiCall = useApiCall();
  
  const onCoverChange = async() => {
    setBtnLoader(true)
    try {
      let apiData = {
        "cover_picture_id": selectedCover
      }
      let apiRes = await apiCall({method: "post", url: "user-select-cover-picture", data: apiData})
      let newUser = {...state.user}
      newUser.cover_picture = apiRes?.file_path
      localStorage.setItem("userV3", JSON.stringify(newUser));
      dispatch({ type: 'USER_LOGIN', payload: newUser, token: state?.token });
      setBtnLoader(false)
      onSubmit(apiRes?.message);
    } catch (error) {
      onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
    }
  }


  return (
    <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal}`}>
      <div className={`${Style["modal_header"]} ${Style.addMeModal_head}`}>
       
        <h4>Update Cover Photo</h4>

        <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
      </div>

      <div className={`${Style.addMeModal_body}`}>
        <div className={`${Style.dcmb__card}`}>
          <div className={`${Style.dcmb__cardBody}`}>
            <div className="flex flex-col gap-3">
              {state?.coverPhotos?.map((eachPhoto) => (
                <div key={eachPhoto?.id} className={`border-[4px] cursor-pointer ${selectedCover == eachPhoto?.id ? "border-blue-600" : "border-transparent"} rounded-md h-[100px] w-full`} onClick={() => {setSelectedCover(eachPhoto?.id)}}>
                  <img className='h-full object-cover object-center w-full rounded-md' src={eachPhoto?.file_path} alt="" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={`${Style.dcmb__cardFoot}`}>
        <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
        {btnLoader ?
          <button className={`${Style.dcmb__submit} !bg-transparent !border-[#335CFF] !cursor-not-allowed`}>
            <InnerLoader textStatus={false} className={`!w-5 !h-5 !border-2 !border-t-[#335CFF] !border-b-[#335CFF]`} />
          </button>
          :
          <button type='submit' className={`${Style.dcmb__submit} disabled:cursor-not-allowed disabled:opacity-40`} disabled={usedCover == selectedCover} onClick={usedCover == selectedCover ? () => {} : onCoverChange}>Apply</button>
        }
      </div>
    </LeftSidePopupLayout>
  )
}

export default UpdateCoverPhoto